module.exports = __webpack_public_path__ + "img/nav-tweet.29c24664.svg";